import apiUrl from 'helpers/apiUrl';
import axios from 'axios';
import { message } from 'antd';

const uploadSingleFile = async (data: any): Promise<any> => {
  const tokenString = localStorage.getItem('token');

  return axios
    .post(`${apiUrl(true)}backoffice/files`, data, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      if (response?.data) {
        return response.data;
      }
    })
    .catch((e) => {
      message.error(e.message);
    });
};

const uploadSinglePdfFile = async (data: any): Promise<any> => {
  const tokenString = localStorage.getItem('token');

  return axios
    .post(`${apiUrl(true)}backoffice/files/pdf`, data, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      if (response?.data) {
        return response.data;
      }
    })
    .catch((e) => {
      message.error(e.message);
    });
};

const uploadOriginalSingleFile = async (data: any): Promise<any> => {
  const tokenString = localStorage.getItem('token');

  return axios
    .post(`${apiUrl(true)}backoffice/files/original-file`, data, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      if (response?.data) {
        return response.data;
      }
    })
    .catch((e) => {
      message.error(e.message);
    });
};

const uploadSingleFileWithoutResize = async (data: any): Promise<any> => {
  const tokenString = localStorage.getItem('token');

  return axios
    .post(`${apiUrl(true)}backoffice/files/no-resize-file`, data, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      if (response?.data) {
        return response.data;
      }
    })
    .catch((e) => {
      message.error(e.message);
    });
};

export const uploadSingleFileWithOriginalExtensionResize = async (data: any): Promise<any> => {
  const tokenString = localStorage.getItem('token');

  return axios
    .post(`${apiUrl(true)}backoffice/files/as-png`, data, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      if (response?.data) {
        return response.data;
      }
    })
    .catch((e) => {
      message.error(e.message);
    });
};

const getPhotosRequest = async (): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl(true)}backoffice/files`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      if (response?.data) {
        return response.data;
      }
    })
    .catch((e) => {
      message.error(e.message);
    });
};

const saveUploadedFile = async (file: any[]): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .put(
      `${apiUrl(true)}backoffice/files`,
      {
        file,
      },
      {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(<string>tokenString)?.accessToken
          }`,
        },
      }
    )
    .then((response) => {
      if (response?.data) {
        message.success('Pozytywnie dodano zdjęcie');
      }
    })
    .catch((e) => {
      message.error(e.message);
    });
};

const deleteSingleFile = async (data: any): Promise<any> => {
  const tokenString = localStorage.getItem('token');

  return axios
    .put(`${apiUrl(true)}backoffice/files/delete`, data, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      if (response?.data) {
        return response.data;
      }
    })
    .catch((e) => {
      message.error(e.message);
    });
};

export {
  uploadSingleFile,
  saveUploadedFile,
  getPhotosRequest,
  deleteSingleFile,
  uploadOriginalSingleFile,
  uploadSingleFileWithoutResize,
  uploadSinglePdfFile,
};
